<template>
	<button type="button" class="back-btn" @click="$emit('click')">
		<font-awesome-icon icon="fa-solid fa-arrow-left" /> 返回
	</button>
</template>

<script>
// 详情页通用返回按钮(替代面包屑)，点击事件由父组件处理(通常 goList)
export default {
	name: 'BackButton',
}
</script>

<style scoped>
.back-btn {
	display: inline-flex;
	align-items: center;
	gap: .4rem;
	background: #fff;
	color: #2563eb;
	border: 1.5px solid #dbeafe;
	padding: .5rem 1.15rem;
	border-radius: 999px;
	font-size: .9rem;
	font-weight: 600;
	cursor: pointer;
	box-shadow: 0 2px 6px rgba(37,99,235,.08);
	transition: all .2s ease;
	margin-bottom: 1.25rem;
}
/* 左箭头图标 */
.back-btn svg { width: 13px; height: 13px; transition: transform .2s; }
.back-btn:hover {
	background: #2563eb;
	color: #fff;
	border-color: #2563eb;
	box-shadow: 0 8px 18px rgba(37,99,235,.28);
}
.back-btn:hover svg { transform: translateX(-2px); }
</style>
